import { Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
@Component({
  selector: 'app-delete-prob-allowed-gt',
  templateUrl: './delete-prob-allowed-gt.component.html',
  styleUrls: ['./delete-prob-allowed-gt.component.scss']
})
export class DeleteProbAllowedGtComponent implements OnInit {
  itemData:any;
  yesFlag: boolean;
  apiUrl: any;
  Type:any;

  constructor(public dialogRef: MatDialogRef<DeleteProbAllowedGtComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog,
    private endpointsService:EndpointsService,private backendApiService : BackendApiService,private router: Router,
    private spinnerService:Ng4LoadingSpinnerService) { }

  ngOnInit(): void {
    console.log("aaaa",this.itemData)
    this.itemData=this.data.rowData;
    this.Type=this.data.type;
    console.log("itemdata",this.itemData)
    console.log("tttty",this.Type)
  }
  clickNo() {
    this.dialogRef.close();
  }
  clickYes() {
    this.spinnerService.show();
    const apiUrl1 = this.endpointsService.URL_DELETE_RRMS_PROBRDB_ALLOWED_GT + '&gt=' + this.itemData.gt + '&type=' + this.Type 

    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      if(response){
        this.spinnerService.show()
        alert("Deleted Sucessfully");
        setTimeout(()=>{
          this.onReset()
        },500)
       
      }
    })
  }
  onReset() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
    // this.spinnerService.show();
  }

}
